"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genTSpmLinkByUrl = void 0;
var tyrande_1 = require("tyrande");
exports.genTSpmLinkByUrl = function (url, order, name, productOrder, spm) {
    var site = spm.site, pageId = spm.pageId, activityId = spm.activityId, componentType = spm.componentType, index = spm.index;
    var isProductWithTag = componentType === tyrande_1.ComponentType.ProductWithTag;
    var params = {
        site: site,
        activityId: activityId,
        pageId: pageId,
        channel: index,
        channelContent: {
            type: componentType,
            order: isProductWithTag ? order : "00",
            content: isProductWithTag ? name : "00",
            productOrder: productOrder
        }
    };
    return tyrande_1.genSpmLink(__assign(__assign({}, params), { url: url }), false);
};
